"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var ImageAsset = /** @class */ (function () {
    function ImageAsset() {
    }
    return ImageAsset;
}());
exports.ImageAsset = ImageAsset;
//# sourceMappingURL=ImageAsset.js.map